// deductionSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { DeductionState } from './deductionTypes';
import {createDeduction,updateDeduction,deleteDeduction,fetchDeductionById,fetchAllDeductions} from './deductionAction';

const initialState: DeductionState = {
    deductions: [],
    selectedDeduction: undefined,
    loading: false,
    error: undefined,
};

const deductionSlice = createSlice({
    name: 'deductions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Deduction
            .addCase(createDeduction.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createDeduction.fulfilled, (state, action) => {
                state.loading = false;
                state.deductions.push(action.payload);
            })
            .addCase(createDeduction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Deduction
            .addCase(updateDeduction.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateDeduction.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.deductions.findIndex(dep => dep.Id === action.payload.Id);
                if (index !== -1) {
                    state.deductions[index] = action.payload;
                }
            })
            .addCase(updateDeduction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Deduction
            .addCase(deleteDeduction.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteDeduction.fulfilled, (state, action) => {
                state.loading = false;
                state.deductions = state.deductions.filter(dep => dep.Id !== action.meta.arg.deductionId);
            })
            .addCase(deleteDeduction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Deduction by ID
            .addCase(fetchDeductionById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchDeductionById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedDeduction = action.payload;
            })
            .addCase(fetchDeductionById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Deductions
            .addCase(fetchAllDeductions.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllDeductions.fulfilled, (state, action) => {
                state.loading = false;
                state.deductions = action.payload;
            })
            .addCase(fetchAllDeductions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default deductionSlice.reducer;
